import React, { useEffect, useState, useRef } from 'react'
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded'
import Button from '@mui/material/Button'

const WarningPopup = (props) => {
  const {
    popupVisible,
    onPopupCancel,
    onPopupOk,
    popupHeadingLabel,
    popupMessageLabel
  } = props

  const handlePopupClose = () => {
    onPopupCancel()
  }

  const handlePopupOk = () => {
    onPopupOk()
  }

  if (popupVisible) {
    return (
      <div
        className='confirm-dialog-main'
        onClick={() => {
          //   handlePopupClose()
        }}
      >
        <div className='confirm-dialog-container'>
          <ErrorOutlineRoundedIcon
            style={{
              width: '50px',
              height: '50px',
              color: '#FF9E2D'
            }}
          />
          <p
            className='confirm-dialog-label1'
            style={{
              color: '#FF9E2D'
            }}
          >
            {popupHeadingLabel}
          </p>
          <p className='confirm-dialog-label2'>{popupMessageLabel}</p>
          <div className='confirm-dialog-button-container'>
            <Button
              variant='outlined'
              style={{
                height: '44px',
                width: '134px',
                borderColor: '#FF9E2D',
                color: '#FF9E2D',
                marginRight: '20px',
                borderRadius: '8px'
              }}
              onClick={() => {
                handlePopupClose()
              }}
            >
              No
            </Button>
            <Button
              variant='contained'
              style={{
                height: '44px',
                width: '134px',
                backgroundColor: '#FF9E2D',
                borderRadius: '8px'
              }}
              onClick={() => {
                handlePopupOk()
              }}
            >
              Yes
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

export { WarningPopup }
